import React from 'react';
const PosKitchenRenderSelectedDeliveryType = (props) => {
    let Delivery = '';
    if(props.selectedOrderType === 'pickup'){
        Delivery = 'Pickup';
    }else if(props.selectedOrderType === 'delivery'){
        Delivery = 'Delivery';
    }else if(props.selectedOrderType === 'dine_in'){
        Delivery = 'Dine-In';
    }else if(props.selectedOrderType === 'takeout'){
        Delivery = 'TakeOut';
    }
  
    return (
        <p className={`deliveryType ${props.pickUpDelivryTextColor} `}>{Delivery}</p>       
    );
};

export default PosKitchenRenderSelectedDeliveryType;